import React from 'react';
import Aux from '../../../../hoc/ReactAux/ReactAux';

const restaurants = props => {
  let teste = id => {
    props.selectRestaurantItem(id);
    props.toggleMenuMobile();
    window.document.getElementById('categories-container').focus();
  };

  return (
    <Aux>
      {props.items &&
        props.items.map(item => (
          <Aux key={item.id}>
            <li
              role="button"
              aria-current={
                props.activeItem && props.activeItem.id === item.id
                  ? 'page'
                  : undefined
              }
              className={
                props.activeItem && props.activeItem.id === item.id
                  ? 'active'
                  : null
              }
              onClick={() => teste(item.id)}
              aria-label={item.name}
              tabIndex={0}
            >
              <a role="presentation">{item.name}</a>
            </li>
          </Aux>
        ))}
    </Aux>
  );
};

export default restaurants;



// WEBPACK FOOTER //
// ./src/containers/Menu/SideBar/Restaurants/Restaurants.js